import { Box, pxToRem, scrollbar, Typography, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const WidgetContainer = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  border: ${pxToRem(1)} solid ${theme.semantic.border.default};
  border-radius: ${theme.borderRadius.lg};
  background-color: ${theme.semantic.surface.primary};
  transition: all 0.2s ease-in-out;

  ${(props) => props.$editMode &&
    `
    &:hover {
      border-color: ${theme.semantic.border.strong};
      box-shadow: 0 0 0 ${pxToRem(2)} color-mix(in srgb, ${theme.semantic.border.default}, transparent 25%);
    }  
  `}
`;
export const WidgetHeader = styled(Box) `
  background-color: ${theme.semantic.surface.primary};
  border-top-left-radius: ${theme.borderRadius.lg};
  border-top-right-radius: ${theme.borderRadius.lg};
  z-index: 1;
`;
export const WidgetBody = styled(Box) `
  height: 100%;
  border-bottom-left-radius: ${theme.borderRadius.lg};
  border-bottom-right-radius: ${theme.borderRadius.lg};
  overflow: auto;

  ${scrollbar({ trackMargin: 'md' })}
`;
export const WidgetDescription = styled(Typography) `
  margin-top: ${theme.spacing.sm};
`;
